var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTitleSheet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#1A1D24",
    fillOpacity: 0.44,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 2.91666L15 1.66666L13.75 2.91666L12.5 1.66666L11.25 2.91666L10 1.66666L8.75 2.91666L7.5 1.66666L6.25 2.91666L5 1.66666V13.3333H2.5V15.8333C2.5 17.2167 3.61667 18.3333 5 18.3333H15C16.3833 18.3333 17.5 17.2167 17.5 15.8333V1.66666L16.25 2.91666ZM12.5 16.6667H5C4.54167 16.6667 4.16667 16.2917 4.16667 15.8333V15H12.5V16.6667ZM15.8333 15.8333C15.8333 16.2917 15.4583 16.6667 15 16.6667C14.5417 16.6667 14.1667 16.2917 14.1667 15.8333V13.3333H6.66667V4.16666H15.8333V15.8333Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.83333H7.5V7.5H12.5V5.83333Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.83333H13.3333V7.5H15V5.83333Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.33333H7.5V10H12.5V8.33333Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.33333H13.3333V10H15V8.33333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleSheet);
export default __webpack_public_path__ + "static/media/titleSheet.f6d7f6b749c0f5f6f6b56104b8698be6.svg";
export { ForwardRef as ReactComponent };